"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _EmptyCartWarningModal = _interopRequireDefault(require("./EmptyCartWarningModal"));

var Styled = _interopRequireWildcard(require("./ChangeAddress.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

var ChangeStore = function ChangeStore(_a) {
  var to = _a.to,
      children = _a.children;

  var _b = (0, _react.useState)(false),
      open = _b[0],
      setOpen = _b[1];

  var handleOnOpen = function handleOnOpen() {
    return setOpen(true);
  };

  var handleOnClose = function handleOnClose() {
    return setOpen(false);
  };

  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(Styled.ChangeAddress, {
    "aria-label": "Change Address",
    as: "button",
    "data-testid": "mini-cart__change-address-link",
    onClick: handleOnOpen
  }, children), _react["default"].createElement(_EmptyCartWarningModal["default"], {
    href: to,
    isOpen: open,
    onClose: handleOnClose
  }));
};

var _default = ChangeStore;
exports["default"] = _default;